import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CheckboxComponent } from './checkbox.component';
import { CheckboxGroupComponent } from './checkbox-group.component';

export const COMPONENTS = [CheckboxComponent, CheckboxGroupComponent];
// import { ChekckboxService } from './checkbox.service';

@NgModule({
    declarations: [...COMPONENTS],
    imports: [CommonModule, FormsModule],
    exports: [...COMPONENTS],
    entryComponents: [...COMPONENTS],
    providers: [],
})
export class CheckboxModule { }
